<template>
	<CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
			<div class="container-fluid">
				<form id="FormCppermisosct" role="form" method="post" autocomplete="off" onSubmit="return false">	
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="Descripcion">Descripción</label>
							<textarea v-model="objCpPermisoSct.Descripcion" class="form-control" id="Descripcion" placeholder="Ingresar Descripción" rows="3"></textarea>
							<CValidation v-if="this.errorvalidacion.Descripcion" :Mensaje="'*'+errorvalidacion.Descripcion[0]"/>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="Clave">Clave</label>
							<input type="text" v-model="objCpPermisoSct.Clave" class="form-control" id="Clave" placeholder="Ingresar Clave" />
							<CValidation v-if="this.errorvalidacion.Clave" :Mensaje="'*'+errorvalidacion.Clave[0]"/>
						</div>
					</div>
						
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="IdClaveTransporte">Clave Transporte</label>
							<select v-model="objCpPermisoSct.IdClaveTransporte" class="form-control-search form-select" id="IdClaveTransporte">
								<option value="">Seleccione una opción</option>
								<option v-for="(item, index) in ListaClavesTransporte" :key="index" :value="item.IdClaveTransporte">{{item.Nombre}}</option>
							</select>
							<CValidation v-if="this.errorvalidacion.IdClaveTransporte" :Mensaje="'*'+errorvalidacion.IdClaveTransporte[0]"/>
						</div>
					</div>

					<br>
				
				</form>
			</div>
		</template>
	</CLoader>
</template>

<script>

export default {
    name: 'FormCppermisosct',
    props: ['poBtnSave'],
    components:{
    },
    data() {
        return {
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            objCpPermisoSct: {
				IdPermisoSct: 0,
				Descripcion: '',
				Clave: '',
				IdClaveTransporte: ''				
            },
            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion,
			//masks:{ input: 'YYYY-MM-DD'}, // quitar sino lleva fecha
			ListaClavesTransporte: [],
        }
    },
    methods :
    {
       	async Guardar()
        {
			this.errorvalidacion = [];
            this.poBtnSave.Toast = 0; 
            this.poBtnSave.DisableBtn = true;

			if(this.objCpPermisoSct.IdPermisoSct == 0) {
				await this.$http.post(
					'cpPermisosSct',this.objCpPermisoSct
				).then((res)=>{
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			} else {
				await this.$http.put(
					'cpPermisosSct/'+this.objCpPermisoSct.IdPermisoSct,
					this.objCpPermisoSct
				).then((res)=>{                 
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			}
        },
		EjecutaConExito(res)
        {
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_'+this.Emit);
        },
        EjecutaConError(err)
        {
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
		Recuperar()
        {
            this.$http.get(
                "cpPermisosSct/"+this.objCpPermisoSct.IdPermisoSct
            ).then((res) => {
                this.objCpPermisoSct = res.data.data;

				// en caso de que necesite fecha
				/*let formatedDate1 = this.objCpPermisoSct.Fecha.replace(/-/g,'\/');
                this.objCpPermisoSct.Fecha = new Date(formatedDate1);*/
            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },
        Limpiar()
        {
            this.objCpPermisoSct = {
				IdPermisoSct: 0,
				Descripcion: '',
				Clave: '',
				IdClaveTransporte: '',
            }
            this.errorvalidacion = [];
        },
		GetListClavesTransporte()
		{
			this.$http.get("cpClavesTransporte", {
				params:{
					simple: 1,
				}
			}).then((res) => {
				this.ListaClavesTransporte = res.data.data;
			});
		},
    },
    created() {
		this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id)=>
        {
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;
			this.GetListClavesTransporte();

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
            this.Limpiar();
                
            if (Id!='') 
            {
                this.objCpPermisoSct.IdPermisoSct = Id;
                this.Recuperar();
            }
            else
            {
                this.ConfigLoad.ShowLoader = false;
            }
        });
    }
}
</script>
